import DepositACheckPage from "components/pages/DepositACheckPage"
export default function CaptureMabiQuickTourDeposits(props) {
    return <DepositACheckPage />
}